import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';

export default function Header() {
    const [openMenu, setOpenMenu] = React.useState(false);

    const menuClassNames = "dropdown-menu dropdown-menu-right header_drop_icon" + (openMenu ? " d-block" : "");

    return (
        <div className="header">
            <div className="header-top d-flex justify-content-between">
                <div className="logo">
                    <a href="/">
                        <img src="/assets/chat/img/logof.png" alt="" className="header_image" />
                    </a>
                </div>
                <ul className="header-action">
                    <li>
                        <button className="btn" onClick={() => setOpenMenu(prevState => !prevState)}>
                            <FontAwesomeIcon className="ellipse_header" icon={faEllipsisH} />
                        </button>
                        <div className={menuClassNames}>
                            <a className="dropdown-item" href="/signin">Daxil Ol</a>
                            <a className="dropdown-item" href="/sigup">Qeydiyyat</a>
                            <a className="dropdown-item" href="/contact">Əlaqə</a>
                        </div>
                    </li>
                </ul>
            </div>
            <ul className="nav nav-tabs chat-tabs mt-3">
                <li className="nav-item">
                    <a className="nav-link" href="/autos">Elanlar</a>
                </li>
                <li className="nav-item ml-1">
                    <a className="nav-link active" href="/chat">Chat</a>
                </li>
                <li className="nav-item ml-1">
                    <a className="nav-link" href="/articles">Məqalələr</a>
                </li>
                <li className="nav-item ml-1">
                    <a className="nav-link" href="/signin">Giriş</a>
                </li>
            </ul>
        </div>
    );
}
